Page = {
  ProductindSlider: function(){
    if($(window).width() < 768) {
      $('.product-ind-slider').slick({
        dots: true,
        infinite: true,
        arrows: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  },
  BlogSlider: function(){
    if($(window).width() > 768) {
      $('.blog-slider').slick({
        dots: false,
        infinite: false,
        vertical: true,
        arrows: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1
      });
    }
  },
  TeamSlider: function(){
    if($(window).width() < 768) {
    $('.team-slider').slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 200,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 767,
          settings: {
            centerMode: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
    }
    
    if($(window).width() >= 768) {
    $('.desktop-slider').slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 200,
      slidesToShow: 4,
      slidesToScroll: 1
    });
    }
  }
}

$(function (){
  'use strict';  
  Page.ProductindSlider();
  Page.BlogSlider();
  Page.TeamSlider();
});


$( window ).resize(function () {  
  Page.ProductindSlider();
  Page.BlogSlider();
  Page.TeamSlider();
});
